import React from 'react';
import GlobalStyles from './styles/GlobalStyles';
import HomePage from './pages/HomePage';

function App() {
  return (
    <>
      <GlobalStyles />
      <HomePage />
    </>
  );
}

export default App; 